```vue
<template>
  <div class="row">
    <div class="col-md-12 col-xxl-12 col-sm-12 mb-10">
      <div class="card mb-25 border-0 rounded-0">
        <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
          <div class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
            <h4 class="position-relative text-black fw-bold mb-10">Informations générales</h4>
            <router-link to="/liste-questions" 
              class="btn btn-primary transition border-0 lh-1 fw-medium">
              <i class="flaticon-left-arrow lh-1 me-1 position-relative top-2"></i>
              <span class="position-relative">Retour</span>
            </router-link>
          </div>
          <table class="table">
            <tbody>
              <tr>
                <td>Contenu</td>
                <td>{{ question?.contenu }}</td>
              </tr>
              <tr>
                <td>Type</td>
                <td>{{ question?.type }}</td>
              </tr>
              
              <tr>
                <td>Date de création</td>
                <td>{{ format_date(question?.createdAt) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="col-md-12 col-xxl-12 col-sm-12 mb-10" v-if="question?.propositions?.length">
      <div class="card mb-25 border-0 rounded-0">
        <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
          <div class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
            <h4 class="position-relative text-black fw-bold mb-10">Propositions associées</h4>
          </div>
          <table class="table">
            <thead>
              <tr>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                >
                  CONTENU
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                >
                  EST LA BONNE RÉPONSE
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                >
                  DATE CRÉATION
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(proposition, index) in question?.propositions" :key="index">
                <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                  {{ proposition.contenu }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                  {{ proposition.estLaBonneReponse ? 'Oui' : 'Non' }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                  {{ format_date(proposition.createdAt) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
/* eslint-disable no-undef */
import { defineComponent, onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';
import ApiService from '@/services/ApiService';
import { error, format_date } from '@/utils/utils';
import { AxiosResponse } from 'axios';

// Interfaces locales
interface ApiResponse {
  code: number;
  data: any;
  message: string;
}

interface Question {
  id: number;
  contenu: string;
  type: string;
  propositions?: Array<{ id: number; contenu: string; estLaBonneReponse: boolean; createdAt: Date }>;
  createdAt: Date;
}

interface AxiosErrorResponse {
  data: {
    message: string;
  };
}

export default defineComponent({
  name: 'ViewQuestion',
  setup() {
    const route = useRoute();
    const question = ref<Question | null>(null);

    function getQuestion(id: string) {
      return ApiService.get(`/questions/${id}`)
        .then(({ data }: AxiosResponse<ApiResponse>) => {
          question.value = data.data;
        })
        .catch((err: { response: AxiosErrorResponse }) => {
          error(err.response.data.message);
        });
    }

    onMounted(() => {
      const id = route.params.id as string;
      getQuestion(id);
    });

    return {
      question,
      getQuestion,
      format_date,
    };
  },
});
</script>
